"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Types", {
    enumerable: true,
    get: function() {
        return _types;
    }
});
_export_star(require("./appearances"), exports);
_export_star(require("./arenas"), exports);
_export_star(require("./brands"), exports);
_export_star(require("./championships"), exports);
_export_star(require("./data"), exports);
_export_star(require("./draft"), exports);
_export_star(require("./faction"), exports);
_export_star(require("./feuds"), exports);
_export_star(require("./game"), exports);
_export_star(require("./productions"), exports);
_export_star(require("./reigns"), exports);
_export_star(require("./rumble"), exports);
_export_star(require("./segments"), exports);
_export_star(require("./tournaments"), exports);
_export_star(require("./shows"), exports);
_export_star(require("./wrestlers"), exports);
const _types = /*#__PURE__*/ _interop_require_wildcard(require("./types/index.js"));
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
